const LABELS = {
  TITLES: {
    ACTIVE: 'Ativo',
    INACTIVE: 'Inativo'
  }
};

export default LABELS;
